import clsx from "clsx";
import { KTIcon } from "../../helpers";
import { useLayout } from "../../layout/core";
import { LeftHeaderContainer } from "./LeftHeaderContainer";
import { RightHeaderContainer } from "./RightHeaderContainer";
import React from "react";
export function HeaderWrapper() {
  const { config, classes } = useLayout();
  if (!config.app?.header?.display) {
    return null;
  }

  return (
    <div id="kt_app_header" className="app-header">
      <div
        className={clsx(
          "app-container bh-white w-100 flex-lg-grow-1",
          classes.headerContainer.join(" "),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <div
            className="d-flex align-items-center d-lg-none ms-n2 me-2"
            title="Show sidebar menu"
          >
            <div
              className="btn btn-icon btn-active-color-primary w-35px h-35px"
              id="n_one_app_sidebar_mobile_toggle"
            >
              <KTIcon iconName="abstract-14" className=" fs-1" />
            </div>
          </div>
        )}

        <div
          id="n_one_app_header_wrapper"
          className="d-flex align-items-stretch justify-content-between flex-lg-grow-1"
        >
          {config.app.header.default?.content === "menu" &&
            config.app.header.default.menu?.display && (
              <div
                className="app-header-menu app-header-mobile-drawer align-items-stretch"
                data-kt-drawer="true"
                data-kt-drawer-name="app-header-menu"
                data-kt-drawer-activate="{default: true, lg: false}"
                data-kt-drawer-overlay="true"
                data-kt-drawer-width="225px"
                data-kt-drawer-direction="end"
                data-kt-drawer-toggle="#n_one_app_header_menu_toggle"
                data-kt-swapper="true"
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#n_one_app_header_wrapper'}"
              >
                {/* Left section of Navbar */}
                <LeftHeaderContainer />
                {/* <Header /> */}
              </div>
            )}
          {/*  Right section of Navbar */}
          <RightHeaderContainer />
        </div>
      </div>
    </div>
  );
}
